import { nomeRun, passiRun, percentualeAvanzamento, quando } from './Functions'
import { Icona } from './Icon'
import { t } from './testi'

/**
 * La riga «Run in corso» sopra tutto: nome, avanzamento e un bottone per seguirla. Se la
 * run attiva non è nella pagina corrente dell'elenco (filtri, pagina) mostra solo lo stato.
 * @param {Object} props - Proprietà
 * @param {Object|undefined} props.run - La run attiva, se è fra quelle lette
 * @param {number} props.inCoda - Quante aspettano
 * @param {() => void} props.onSegui - Apre il dettaglio della run attiva
 */
export const BannerRunAttiva = ({ run, inCoda, onSegui }) => {
  const percentuale = run ? percentualeAvanzamento(run) : null
  const passi = run ? passiRun(run) : null
  return (
    <div className="ae-banner" role="status" aria-live="polite">
      <Icona nome="pi-spin pi-spinner" />
      <div className="ae-banner__testo">
        <strong>{t.aeRunAttiva}</strong>
        <span className="ae-muto">
          {run
            ? `${nomeRun(run) || quando(run.avviataIl)} · ${passi.fatti + (passi.saltati ?? 0)}/${passi.totali}`
            : t.aeRunInCorso}
          {inCoda ? ` · ${inCoda} ${t.aeInCoda}` : ''}
        </span>
      </div>
      {run ? (
        <span
          className="ae-barra-passi ae-barra-passi--banner"
          role="progressbar"
          aria-label={t.aeAvanzamento}
          aria-valuenow={percentuale}
          aria-valuemin={0}
          aria-valuemax={100}
        >
          <span style={{ width: `${percentuale}%` }} />
        </span>
      ) : null}
      <button type="button" className="nbtn nbtn--ghost nbtn--sm" onClick={onSegui}>
        {t.aeSegui}
      </button>
    </div>
  )
}
